import { useState, useEffect } from 'react';
import { supabase } from './supabase';
import { C } from './constants';
import { Landing, AvisoPrivacidad, TerminosCondiciones } from './components/Landing';
import { Cargando } from './components/Cargando';
import { Login, Registro } from './pages/Login';
import { MisTandas, MenuHamburguesa, Proximamente, PreguntasFrecuentesApp, Explorar, MisPagos } from './pages/MisTandas';
import { MiPerfil } from './pages/MiPerfil';
import { PanelAdmin } from './pages/PanelAdmin';
import { Dashboard } from './pages/Dashboard';

export default function App() {
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      html, body { overflow-x: hidden !important; overscroll-behavior-x: none !important; touch-action: pan-y !important; max-width: 100vw; }
      * { box-sizing: border-box; }
      body { -webkit-tap-highlight-color: transparent; -webkit-touch-callout: none; }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const [vista, setVista] = useState('landing');
  const [vistaApp, setVistaApp] = useState('tandas');
  const [session, setSession] = useState(null);
  const [usuario, setUsuario] = useState(null);
  const [loadingUser, setLoadingUser] = useState(true);
  const [showBanner, setShowBanner] = useState(true);
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [skipWhatsApp, setSkipWhatsApp] = useState(false);
  const [skipBanco, setSkipBanco] = useState(false);
  const [bancoSeleccionado, setBancoSeleccionado] = useState('');
  const [guardandoBanco, setGuardandoBanco] = useState(false);

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      if (session) cargarUsuario(session.user.id);
      else setLoadingUser(false);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_e, session) => {
      setSession(session);
      setMenuAbierto(false);
      if (session) cargarUsuario(session.user.id);
      else { setUsuario(null); setLoadingUser(false); }
    });
    return () => subscription.unsubscribe();
  }, []);

  const cargarUsuario = async (userId) => {
    const { data } = await supabase.from('usuarios').select('*').eq('id', userId).single();
    if (data) { setUsuario(data); setLoadingUser(false); }
    else {
      setTimeout(async () => {
        const { data: d2 } = await supabase.from('usuarios').select('*').eq('id', userId).single();
        setUsuario(d2 || null); setLoadingUser(false);
      }, 2000);
    }
  };

  const handleReset = async () => {
    await supabase.auth.signOut();
    setMenuAbierto(false);
    setSession(null); setUsuario(null); setLoadingUser(false); setVista('landing');
  };

  const handleNavegar = (destino) => {
    setMenuAbierto(false);
    if (destino === 'asistente') {
      window.location.href = 'https://wa.me/5214793915920?text=Hola%2C%20tengo%20una%20pregunta';
      return;
    }
    setVistaApp(destino);
  };

  const irAHome = () => window.location.reload();

  if (loadingUser) return <Cargando onReset={handleReset} />;

  // Dashboard secreto admin — solo renderizar después de verificar sesión
  const esDashboard = new URLSearchParams(window.location.search).get('panel') === 'admin';
  if (esDashboard) return <Dashboard />;

  return (
    <div style={{ minHeight: '100vh', background: C.gray50, fontFamily: "'Plus Jakarta Sans', sans-serif", maxWidth: 480, margin: '0 auto' }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800;900&display=swap');
        *{box-sizing:border-box;margin:0;padding:0;}
        input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;}
      `}</style>

      {session && usuario && !skipWhatsApp && !usuario.whatsapp_activado && (
        <div style={{ minHeight: '100vh', background: C.gray50, fontFamily: "'Plus Jakarta Sans', sans-serif", maxWidth: 480, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '32px 20px' }}>
          <div style={{ background: '#fff', borderRadius: 20, padding: '36px 24px', boxShadow: '0 4px 24px rgba(0,0,0,0.1)', textAlign: 'center', width: '100%' }}>
            <div style={{ fontSize: 56, marginBottom: 16 }}>🔔</div>
            <div style={{ fontSize: 22, fontWeight: 900, color: '#1E293B', marginBottom: 8 }}>Activa tus recordatorios</div>
            <div style={{ fontSize: 14, color: '#64748B', lineHeight: 1.6, marginBottom: 24 }}>
              Te avisamos por WhatsApp antes de cada fecha limite de pago para que estes siempre al corriente y sin amonestaciones.
            </div>
            <a href="https://wa.me/5214793915920?text=Activar%20recordatorios"
              style={{ display: 'block', background: '#25D366', color: '#fff', fontSize: 16, fontWeight: 700, padding: '14px 0', borderRadius: 12, textDecoration: 'none', marginBottom: 12 }}>
              Activar recordatorios por WhatsApp
            </a>
            <button onClick={() => setSkipWhatsApp(true)}
              style={{ background: 'none', border: 'none', color: '#94A3B8', fontSize: 13, cursor: 'pointer', padding: '8px 0', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              Ahora no
            </button>
          </div>
        </div>
      )}

      {session && usuario && (skipWhatsApp || usuario.whatsapp_activado) && !skipBanco && usuario.metodo_cobro === 'spei' && !usuario.banco && (
        <div style={{ minHeight: '100vh', background: C.gray50, fontFamily: "'Plus Jakarta Sans', sans-serif", maxWidth: 480, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '32px 20px' }}>
          <div style={{ background: '#fff', borderRadius: 20, padding: '36px 24px', boxShadow: '0 4px 24px rgba(0,0,0,0.1)', textAlign: 'center', width: '100%' }}>
            <div style={{ fontSize: 56, marginBottom: 16 }}>🏦</div>
            <div style={{ fontSize: 22, fontWeight: 900, color: '#1E293B', marginBottom: 8 }}>Completa tu banco</div>
            <div style={{ fontSize: 14, color: '#64748B', lineHeight: 1.6, marginBottom: 24 }}>
              Necesitamos saber tu banco para poder depositarte cuando sea tu turno de cobrar.
            </div>
            <select value={bancoSeleccionado} onChange={e => setBancoSeleccionado(e.target.value)}
              style={{ width: '100%', padding: '14px', borderRadius: 12, border: '1.5px solid #E2E8F0', fontSize: 15, color: bancoSeleccionado ? '#1E293B' : '#94A3B8', background: '#fff', marginBottom: 16, fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              <option value="">Selecciona tu banco</option>
              {['BBVA','Banorte','Santander','HSBC','Scotiabank','Citibanamex','Banco Azteca','BanCoppel','Spin by OXXO','Nu','Rappi','Mercado Pago','Hey Banco','Inbursa','Banregio','Afirme','BanBajio','Otro'].map(b => <option key={b} value={b}>{b}</option>)}
            </select>
            <button onClick={async () => {
              if (!bancoSeleccionado) return;
              setGuardandoBanco(true);
              const { error } = await supabase.from('usuarios').update({ banco: bancoSeleccionado }).eq('id', usuario.id);
              if (error) { setGuardandoBanco(false); return; }
              setUsuario(prev => ({ ...prev, banco: bancoSeleccionado }));
              setSkipBanco(true);
              setGuardandoBanco(false);
            }} disabled={!bancoSeleccionado || guardandoBanco}
              style={{ display: 'block', width: '100%', background: bancoSeleccionado ? '#1A56DB' : '#E2E8F0', color: bancoSeleccionado ? '#fff' : '#94A3B8', fontSize: 16, fontWeight: 700, padding: '14px 0', borderRadius: 12, border: 'none', cursor: bancoSeleccionado ? 'pointer' : 'default', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
              {guardandoBanco ? 'Guardando...' : 'Guardar banco'}
            </button>
          </div>
        </div>
      )}

      {session && usuario && (skipWhatsApp || usuario.whatsapp_activado) && (skipBanco || usuario.banco || usuario.metodo_cobro !== 'spei') && (
        <>
          {menuAbierto && (
            <MenuHamburguesa onClose={() => setMenuAbierto(false)} vistaActual={vistaApp} onNavegar={handleNavegar} onSalir={handleReset} usuario={usuario} />
          )}
          {vistaApp === 'tandas' && <MisTandas usuario={usuario} onMenu={() => setMenuAbierto(true)} onHome={irAHome} onExplorar={() => setVistaApp('explorar')} />}
          {vistaApp === 'perfil' && <MiPerfil usuario={usuario} setUsuario={setUsuario} onMenu={() => setMenuAbierto(true)} onHome={irAHome} />}
          {vistaApp === 'explorar' && <Explorar usuario={usuario} onMenu={() => setMenuAbierto(true)} onHome={irAHome} />}
          {vistaApp === 'pagos' && <MisPagos usuario={usuario} onMenu={() => setMenuAbierto(true)} onHome={irAHome} />}
          {vistaApp === 'referidos' && <Proximamente icon="👥" titulo="Referidos" descripcion="Invita amigos a TandaClick y sube de nivel más rápido con cada referido activo." onMenu={() => setMenuAbierto(true)} onHome={irAHome} />}
          {vistaApp === 'admin' && usuario?.rol === 'admin' && <PanelAdmin usuario={usuario} onMenu={() => setMenuAbierto(true)} onHome={irAHome} />}
          {vistaApp === 'faq' && <PreguntasFrecuentesApp onMenu={() => setMenuAbierto(true)} onHome={irAHome} />}
        </>
      )}
      {session && !usuario && <Cargando onReset={handleReset} />}

      {!session && vista === 'aviso' && <AvisoPrivacidad onBack={() => setVista('landing')} />}
      {!session && vista === 'terminos' && <TerminosCondiciones onBack={() => setVista('landing')} />}
      {!session && vista === 'landing' && (
        <Landing onEntrar={() => setVista('login')} showBanner={showBanner} onDismissBanner={() => setShowBanner(false)} onAviso={() => setVista('aviso')} onTerminos={() => setVista('terminos')} />
      )}
      {!session && vista === 'login' && <Login onRegistro={() => setVista('registro')} onLanding={() => setVista('landing')} />}
      {!session && vista === 'registro' && (
        <Registro onLogin={() => setVista('login')} onAviso={() => setVista('aviso')} onTerminos={() => setVista('terminos')} />
      )}
    </div>
  );
}
